import { Link } from 'react-router-dom';
import { styled } from 'styled-components';

export const ResponseIdLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.defaultGrayBgColor};
  color: ${({ theme }) => theme.textColor};

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.textColor};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 1px;
  }
`;
